export default "__VITE_ASSET__COOXLFVr__"